import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5d611894"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Preguntas frecuentes", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, "Pulsa sobre las distintas preguntas para ver su respuesta.", -1))
const _hoisted_7 = { class: "accordion" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "accordion-body"
}

import DefaultLayout from '../layouts/DefaultLayout.vue'
import { ref, onMounted } from 'vue'
import FaqsService from '@/services/FaqsService'
import FaqI from '@/interfaces/FaqInterface' 


export default /*#__PURE__*/_defineComponent({
  __name: 'FaqsView',
  setup(__props) {

const loading = ref(false)
const service = new FaqsService()
const faqs = ref<FaqI[]>([])

const toggle = (id: number) => {
  faqs.value = faqs.value.map(faq =>
    faq.id === id ? { ...faq, open: !faq.open } : faq
  )
}

onMounted(async () => {
  loading.value = true
  const fetchedFaqs = await service.GetFaqs()
  faqs.value = fetchedFaqs.map((faq:any) => ({ ...faq, open: false }))
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faqs.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "accordion-item"
                  }, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (toggle(item.id)),
                      class: "accordion-header"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(item.question), 1),
                      _createVNode(_component_v_icon, {
                        name: item.open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line',
                        class: "icon"
                      }, null, 8, ["name"])
                    ], 8, _hoisted_8),
                    (item.open)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("p", null, _toDisplayString(item.content), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})